import { ScrollArea } from '@/components/shadcn/scroll-area'
import { InferFormValues, JsonFormSchemaV2 } from '../FormComponent/types'
import { UISchema, DataSchema } from './types'
import { SingleCard } from './SingleCard'
import { TileFilter } from '../TileFilter'
import { ComponentTitle } from '../ComponentTitle'

export function CardsContent({
  tileFilterSchema,
  filterChangeHandler,
  uiSchema,
  dataSchema,
}: {
  tileFilterSchema: JsonFormSchemaV2
  filterChangeHandler: (data: InferFormValues<JsonFormSchemaV2>) => void
  uiSchema: UISchema
  dataSchema: DataSchema
}) {
  const { title = undefined, description = undefined, layout, cards } = uiSchema
  return (
    <div className="flex h-full flex-col">
      {title && (
        <div className="flex w-full flex-wrap items-center justify-between gap-4 border-b pb-4">
          <ComponentTitle title={title} description={description} />
          <TileFilter schema={tileFilterSchema} submitHandler={filterChangeHandler} />
        </div>
      )}
      <ScrollArea className="h-full">
        <div style={{ gridTemplateColumns: `repeat(${layout.columns}, minmax(0, 1fr))` }} className="grid gap-6 py-5">
          {cards.map((card) => {
            const cardData = dataSchema.data.find((data) => data.id === card.id) || { id: card.id }
            return <SingleCard key={card.id} card={card} data={cardData} />
          })}
        </div>
      </ScrollArea>
    </div>
  )
}
